export default __webpack_public_path__ + "static/media/checkWhite.0ce61e6b.svg";